// extracted by mini-css-extract-plugin
module.exports = {"banner":"EiKfclg7","banner__firstChild":"Ti04L40n"};